import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import { Trans } from 'react-i18next';
import { Button, Col, Modal, Row, Text } from '@ui';

interface IProps {
  helpTitle: string;
  helpDescription: string | React.ReactNode;
}

const HelpAndWithdrawSection = ({ helpTitle, helpDescription }: IProps) => {
  const { t } = useTranslation(['onboarding', 'common']);
  const { withdrawApplication } = useEntityIntakeFormContext();

  const handleWithdrawClick = () => {
    Modal.confirm({
      title: t('intake_form.withdraw_section.confirmation_modal.title'),
      width: 600,
      icon: null,
      closable: true,
      maskClosable: true,
      content: (
        <>
          <Text gutterBottom>
            {t(
              'intake_form.withdraw_section.confirmation_modal.description_line_1',
            )}
          </Text>
          <Text>
            <Trans
              t={t}
              i18nKey="intake_form.withdraw_section.confirmation_modal.description_line_2"
              components={[
                <Text variant="span" color={colorsTheme.colorWhite} />,
              ]}
            />
          </Text>
        </>
      ),
      okText: t('confirm', { ns: 'common' }),
      async onOk() {
        await withdrawApplication();
      },
    });
  };

  return (
    <Row gutter={[24, 24]}>
      <Col span={12}>
        <MinHeightWrapper>
          <StyledText variant="h4" gutterBottom>
            {helpTitle}
          </StyledText>
          <StyledText>{helpDescription}</StyledText>
        </MinHeightWrapper>
      </Col>
      <Col span={12}>
        <MinHeightWrapper>
          <StyledText variant="h4" gutterBottom color={colorsTheme.colorWhite}>
            {t('intake_form.withdraw_section.title')}
          </StyledText>
          <StyledText>
            {t('intake_form.withdraw_section.description')}
          </StyledText>
        </MinHeightWrapper>
        <Button size="large" danger onClick={handleWithdrawClick}>
          {t('intake_form.withdraw_section.button')}
        </Button>
      </Col>
    </Row>
  );
};

const StyledText = styled(Text)`
  margin-bottom: ${({ theme }) => theme.marginSm};
`;

const MinHeightWrapper = styled.div`
  min-height: 100px;
`;

export default HelpAndWithdrawSection;
